import { getAudienceAccessType } from 'ContentUtils/helpers/AudienceAccessHelpers';
import { useSelector } from 'react-redux';
import { getContentModelPassword, getContentModelPublicAccessRules, getContentModelPublicAccessRulesEnabled
// @ts-expect-error Untyped module
} from 'page-editor-ui/redux/selectors/pageContentModelSelectors';
const useAudienceAccessType = () => {
  const publicAccessRules = useSelector(getContentModelPublicAccessRules);
  const publicAccessRulesEnabled = useSelector(getContentModelPublicAccessRulesEnabled);
  const password = useSelector(getContentModelPassword);
  const audienceAccessType = getAudienceAccessType({
    password,
    publicAccessRules,
    publicAccessRulesEnabled
  });
  return audienceAccessType;
};
export default useAudienceAccessType;